export default {
  'rate.status.pending': 'Pending',
  'rate.status.active': 'Active',
  'rate.status.expired': 'Expired',
  'rate.status.inactive': 'Inactive',
  'rate.field.code': 'Code',
  'rate.field.name': 'Title',
  'rate.field.effective_date': 'Effective Date',
  'rate.field.expiry_date': 'Expiry Date',
  'rate.field.contract': 'Contract',
  'rate.field.owner': 'Owner',
  'rate.field.vendor': 'Vendor',
  'rate.field.is_active': 'Active',
  'rate.details': 'Rate',
  'rate.create': 'Create Rate',
  'rate.type.spot': 'Spot',
  'rate.type.contract': 'Contract',
  'rate.type.export_origin': 'Export Origin',
  'rate.type.import_destination': 'Import Destination',
  'rate.title.route': 'Route',
  'rate.field.charge_items': 'Charge Items',
  'rate.field.quotation_code': 'Quotation Number',
  'rate.category.ocean': 'Ocean Rate',
  'rate.category.handling': 'Handling Rate',
  'rate.category.ocean.list_title': 'Ocean Rates',
  'rate.category.handling.list_title': 'Handling Rates',
  'rate.category.ocean.create': 'Create Ocean Rate',
  'rate.category.handling.create': 'Create Handling Rate',
  'rate.field.source': 'Source',
};
